/**
 * Sidebar Recently Viewed Products Module v3.0
 * 컴렉션 사이드바에 최근 본 상품을 표시합니다.
 * 
 * v3.0: EDM API 직접 사용으로 중복 코드 제거, 가격 포맷팅 통합
 */

(function() {
  // Prevent multiple declarations
  if (customElements.get('sidebar-recently-viewed')) {
    return;
  }

  /**
   * EDM 통합 가격 포맷팅 유틸리티
   */
  const PriceUtils = {
    formatCents(cents) {
      if (!cents && cents !== 0) return '';
      // 통화 코드 토글까지 반영하는 공용 포매터 (assets/money-format.js) 우선
      const shared = window.WookieMoney?.display?.(cents);
      if (shared) return shared;
      if (window.EDMDiscounts?.formatPrice) return window.EDMDiscounts.formatPrice(cents);
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
      return '$' + (cents / 100).toFixed(2);
    },
    formatPrice(amount) {
      if (!amount && amount !== 0) return '';
      const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
      if (isNaN(numAmount)) return '';
      return this.formatCents(numAmount * 100);
    }
  };

  class SidebarRecentlyViewed extends HTMLElement {
  constructor() {
    super();
    this.contentContainer = null;
    this.cookieName = "wokiee_recently_viewed";
  }

  connectedCallback() {
    this.contentContainer = this.querySelector('.sidebar-recently-viewed-content');
    if (this.contentContainer) {
      this.loadRecentlyViewed();
    }
  }

  // 쿠키 읽기
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) {
        var arr = c.substring(nameEQ.length,c.length);
        return arr ? arr.split(' ').filter(item => item.length > 0) : [];
      }
    }
    return [];
  }

  getRecentlyViewedProducts() {
    try {
      return this.getCookie(this.cookieName);
    } catch (e) {
      console.warn('Failed to get recently viewed products:', e);
      return [];
    }
  }

  config() {
    return {
      count: parseInt(this.getAttribute('data-count')) || 4,
      cookieDays: parseInt(this.getAttribute('data-cookie-days')) || 30,
      settings: this.getAttribute('data-settings') || ''
    };
  }

  parseSettings() {
    const settingsStr = this.config().settings;
    const settings = {};
    
    if (settingsStr) {
      settingsStr.split('___').forEach(item => {
        const [key, value] = item.split('||');
        if (key && value !== undefined) {
          settings[key] = value === 'true' ? true : value === 'false' ? false : value;
        }
      });
    }
    
    return settings;
  }

  // 현재 페이지의 상품 핸들 제외
  excludeCurrentProduct(products) {
    if (window.location.pathname.indexOf('/products/') === -1) {
      return products;
    }
    
    const productHandleEl = document.querySelector('[data-product-handle]');
    if (!productHandleEl) return products;
    
    const currentHandle = productHandleEl.getAttribute('data-product-handle');
    return products.filter(handle => handle !== currentHandle);
  }

  async loadRecentlyViewed() {
    const products = this.getRecentlyViewedProducts();
    
    if (products.length === 0) {
      this.style.display = 'none';
      return;
    }

    const count = this.config().count;
    const limitedProducts = products.slice(0, count);
    const settings = this.parseSettings();
    
    // 현재 페이지의 상품은 제외
    const filteredProducts = this.excludeCurrentProduct(limitedProducts);

    if (filteredProducts.length === 0) {
      this.style.display = 'none';
      return;
    }

    try {
      const html = await this.fetchProductsHtml(filteredProducts, settings);
      if (html && this.contentContainer) {
        this.contentContainer.innerHTML = html;
        this.style.display = 'block';
        
        // 이미지 사이즈 속성 설정
        const imageSize = settings.image_size || 'medium';
        this.contentContainer.setAttribute('data-image-size', imageSize);
      }
    } catch (e) {
      console.warn('Failed to load recently viewed products:', e);
      this.style.display = 'none';
    }
  }

  async fetchProductsHtml(handles, settings) {
    const productPromises = handles.map(handle => 
      fetch(`/products/${handle}.json`)
        .then(response => {
          if (!response.ok) throw new Error('Product not found');
          return response.json();
        })
        .then(data => data.product)
        .catch(() => null)
    );

    const products = await Promise.all(productPromises);
    const validProducts = products.filter(p => p !== null);

    if (validProducts.length === 0) return '';

    return validProducts.map(product => this.renderProductItem(product, settings)).join('');
  }

  /**
   * EDM (Enhanced Discount Manager) 호환 상품 아이템 렌더링
   * product-card.liquid 및 sidebar-product-item.liquid와 동일한 구조 사용
   */
  renderProductItem(product, settings) {
    const showPrice = settings.show_price !== false;
    const showVendor = settings.show_vendor === true;
    
    const imageUrl = product.images && product.images.length > 0 
      ? product.images[0].src.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_180x180.$1')
      : '';
    
    const variantId = product.variants[0].id;
    const productId = product.id;
    const price = PriceUtils.formatPrice(product.variants[0].price);
    const compareAtPrice = product.variants[0].compare_at_price 
      ? PriceUtils.formatPrice(product.variants[0].compare_at_price) 
      : null;
    
    const isOnSale = compareAtPrice && parseFloat(product.variants[0].compare_at_price) > parseFloat(product.variants[0].price);
    const hasCompareDiscount = isOnSale ? 'true' : 'false';
    
    /**
     * EDM 호환 가격 HTML 구조:
     * - data-edm-price-container: EDM이 가격 컨테이너를 식별
     * - data-variant-id: EDM이 할인 정보를 매칭
     * - data-product-id: 상품 ID
     * - data-has-compare-discount: compare_at_price 할인 여부
     * - data-edm-compare-wrapper/data-edm-compare-price: 원가 요소
     * - data-edm-sale-price: 할인가 요소
     * - data-edm-original-price: 기본 가격 요소
     */
    let priceHtml = '';
    if (showPrice) {
      if (isOnSale) {
        priceHtml = `
          <div class="sidebar-product-item__price has-compare-discount"
               data-edm-price-container
               data-variant-id="${variantId}"
               data-product-id="${productId}"
               data-has-compare-discount="${hasCompareDiscount}">
            <span class="price price--on-sale">
              <span class="price__regular" data-edm-compare-wrapper>
                <s class="price-item price-item--regular" data-edm-compare-price>${compareAtPrice}</s>
              </span>
              <span class="price__sale price-item price-item--sale" data-edm-sale-price>${price}</span>
            </span>
          </div>
        `;
      } else {
        priceHtml = `
          <div class="sidebar-product-item__price"
               data-edm-price-container
               data-variant-id="${variantId}"
               data-product-id="${productId}"
               data-has-compare-discount="${hasCompareDiscount}">
            <span class="price">
              <span class="price__main price-item" data-edm-original-price>${price}</span>
            </span>
          </div>
        `;
      }
    }
    
    const vendorHtml = showVendor && product.vendor 
      ? `<div class="sidebar-product-item__vendor">${this.escapeHtml(product.vendor)}</div>` 
      : '';
    
    const imageHtml = imageUrl 
      ? `<img src="${imageUrl}" alt="${this.escapeHtml(product.title)}" width="90" height="90" loading="lazy">`
      : '<svg class="placeholder-svg" viewBox="0 0 525 525"><rect fill="#f5f5f5" width="525" height="525"/></svg>';

    return `
      <div class="sidebar-product-item" 
           data-product-handle="${product.handle}"
           data-product-id="${productId}">
        <a href="/products/${product.handle}" class="sidebar-product-item__image">
          ${imageHtml}
        </a>
        <div class="sidebar-product-item__content">
          ${vendorHtml}
          <h4 class="sidebar-product-item__title">
            <a href="/products/${product.handle}">${this.escapeHtml(product.title)}</a>
          </h4>
          ${priceHtml}
        </div>
      </div>
    `;
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
}

customElements.define('sidebar-recently-viewed', SidebarRecentlyViewed);
})();
